/**
 * "Practical info" panel in the Quicklinks bar (single clinic pages only).
 *
 * [data-quicklinks-toggle]      → expands/collapses #quicklinks-info
 * [data-contact-toggle="<key>"] → expands [data-contact-panel="<key>"] and
 *                                 collapses the other contact panels
 *
 * Sections animate their height (0 ⇆ content). They ship with the `hidden`
 * attribute and CSS `overflow-hidden transition-[height] …` (see header.php).
 * Markup: header.php
 */

const TRANSITION_FALLBACK = 320; // ms — safety net if transitionend never fires

function afterHeight( el, done ) {
	let fired = false;
	const finish = () => {
		if ( fired ) {
			return;
		}
		fired = true;
		el.removeEventListener( 'transitionend', onEnd );
		done();
	};
	const onEnd = ( event ) => {
		if ( event.target === el && event.propertyName === 'height' ) {
			finish();
		}
	};
	el.addEventListener( 'transitionend', onEnd );
	setTimeout( finish, TRANSITION_FALLBACK );
}

function expand( el ) {
	if ( ! el.hidden && el.style.height === '' ) {
		return; // already open
	}
	el.hidden = false;
	el.style.height = '0px';
	void el.offsetHeight; // reflow
	el.style.height = el.scrollHeight + 'px';
	afterHeight( el, () => {
		el.style.height = '';
	} );
}

function collapse( el ) {
	if ( el.hidden ) {
		return;
	}
	el.style.height = el.scrollHeight + 'px';
	void el.offsetHeight;
	el.style.height = '0px';
	afterHeight( el, () => {
		el.hidden = true;
		el.style.height = '';
	} );
}

function initQuicklinksInfo() {
	const toggle = document.querySelector( '[data-quicklinks-toggle]' );
	const panel = document.getElementById( 'quicklinks-info' );
	if ( ! toggle || ! panel ) {
		return;
	}

	const contactButtons = [ ...panel.querySelectorAll( '[data-contact-toggle]' ) ];
	const contactPanels = [ ...panel.querySelectorAll( '[data-contact-panel]' ) ];
	const hoursToggle = panel.querySelector( '[data-hours-toggle]' );
	const hoursPanel = document.getElementById( 'quicklinks-hours' );

	const resetSections = () => {
		[ ...contactButtons, hoursToggle ].forEach( ( btn ) => btn && btn.setAttribute( 'aria-expanded', 'false' ) );
		[ ...contactPanels, hoursPanel ].forEach( ( p ) => {
			if ( ! p ) {
				return;
			}
			p.hidden = true;
			p.style.height = '';
		} );
	};

	const closePanel = () => {
		if ( toggle.getAttribute( 'aria-expanded' ) !== 'true' ) {
			return;
		}
		toggle.setAttribute( 'aria-expanded', 'false' );
		collapse( panel );
		afterHeight( panel, resetSections );
	};

	toggle.addEventListener( 'click', ( event ) => {
		event.preventDefault();
		if ( toggle.getAttribute( 'aria-expanded' ) === 'true' ) {
			closePanel();
		} else {
			toggle.setAttribute( 'aria-expanded', 'true' );
			expand( panel );
		}
	} );

	// Opening the main menu closes this panel too.
	const menuToggle = document.querySelector( '.hamburger[aria-controls="main-nav"]' );
	if ( menuToggle ) {
		menuToggle.addEventListener( 'click', closePanel );
	}

	if ( hoursToggle && hoursPanel ) {
		hoursToggle.addEventListener( 'click', () => {
			const open = hoursToggle.getAttribute( 'aria-expanded' ) === 'true';
			hoursToggle.setAttribute( 'aria-expanded', String( ! open ) );
			( open ? collapse : expand )( hoursPanel );
		} );
	}

	contactButtons.forEach( ( btn ) => {
		btn.addEventListener( 'click', () => {
			const wasOpen = btn.getAttribute( 'aria-expanded' ) === 'true';
			const target = panel.querySelector(
				`[data-contact-panel="${ btn.getAttribute( 'data-contact-toggle' ) }"]`
			);

			contactButtons.forEach( ( other ) => {
				if ( other !== btn ) {
					other.setAttribute( 'aria-expanded', 'false' );
				}
			} );
			contactPanels.forEach( ( p ) => {
				if ( p !== target ) {
					collapse( p );
				}
			} );

			btn.setAttribute( 'aria-expanded', String( ! wasOpen ) );
			if ( target ) {
				( wasOpen ? collapse : expand )( target );
			}
		} );
	} );
}

initQuicklinksInfo();
